import makeStandardsList from "../../../shared/containers/make_standards_list";

export default makeStandardsList();
